import { Injectable } from '@angular/core';
import { Plugin } from '../classes/plugin';
import { PluginService } from './plugin.service';

interface Options {
    order?: number,
    columns?: number,
}

interface Data {
    [key: string]: any
}

@Injectable()
export class PluginService2 {

    constructor(protected plugins: PluginService) {
    }

    /**
     * Add a plugin.
     *
     * @param {string | Array<string>} slot
     * @param {string} name
     * @param component
     * @param {Options} options
     * @param {Data} data
     * @return {this}
     */
    public add(slot: string | Array<string>, name: string, component: any, options: Options = {}, data: Data = {}): this {
        const slots = typeof slot === 'string'
            ? [slot]
            : slot;

        slots.forEach((s: string) => {
            this.plugins.add(s, name, component, options.order, data, options);
        });

        return this;
    }

    /**
     * Get a plugin.
     *
     * @return {Plugin}
     */
    public get(slot: string, name: string): Plugin {
        return this.plugins.get(slot, name);
    }

    /**
     * Remove a plugin.
     *
     * @param {string} slot
     * @param {string} name
     * @return {this}
     */
    public remove(slot: string, name: string): this {
        this.plugins.remove(slot, name);

        return this;
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/plugins/services/plugin2.service.ts